import React from 'react'
import { Banner } from './banner'
import { SalesMaterialsSec } from './salesMaterialsSec'

export const SalesMaterials = () => {
  return (
    <>
    <Banner />
    <SalesMaterialsSec />
    </>
  )
}
